import * as internal from "stream";

export class TypesModel {
    typeid: number;
    typecode: string;
    typedescription: string;
    categoryid: number;

    constructor(typeid: number, typecode: string, typedescription: string, categoryid: number) {
        this.typeid = typeid;
        this.typecode = typecode;
        this.typedescription = typedescription;
        this.categoryid = categoryid;
    }
}